exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input[data-v-73f6d49a]{border:1px solid #e5e5e5!important}", ""]);

// exports
